import React from "react";

const WaypointGray = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
			<g id="waypoint_gray" transform="translate(-558 -1129)">
				<g id="gray_ellipse" transform="translate(558 1129)" fill="#b5b9be" stroke="#fff" strokeWidth="1">
					<circle cx="12" cy="12" r="12" stroke="none" />
					<circle cx="12" cy="12" r="11.5" fill="none" />
				</g>
				<path
					id="map-marker-radius"
					d="M10,2a4.517,4.517,0,0,1,4.5,4.533c0,3.4-4.5,8.419-4.5,8.419S5.5,9.931,5.5,6.533A4.517,4.517,0,0,1,10,2m0,3.048a1.524,1.524,0,1,0,1.5,1.524A1.512,1.512,0,0,0,10,5.048m6,9.9C16,16.636,13.315,18,10,18s-6-1.364-6-3.048c0-.983.915-1.859,2.332-2.415l.48.693C6,13.573,5.5,14.046,5.5,14.571c0,1.051,2.017,1.9,4.5,1.9s4.5-.853,4.5-1.9c0-.526-.5-1-1.312-1.341l.48-.693C15.085,13.093,16,13.97,16,14.952Z"
					transform="translate(560 1131)"
					fill="#fff"
				/>
			</g>
		</svg>
	);
};

export default WaypointGray;
